import { CHECKOUT_STATUSES } from '@adapters/bigcommerce/constants';
import { ParsedUrlQuery, encode } from 'querystring';

export type CheckoutStatus =
  (typeof CHECKOUT_STATUSES)[keyof typeof CHECKOUT_STATUSES];

export const buildCheckoutCustomerStatusQuery = ({
  status,
  query: incomingQuery,
  excludeKeys = [],
}: {
  status: CheckoutStatus;
  query: ParsedUrlQuery;
  excludeKeys?: Array<string>;
}) => {
  const query = new URLSearchParams(encode(incomingQuery));
  query.set('memberStatus', status);
  excludeKeys.forEach((key) => query.delete(key));

  return `?${query.toString()}`;
};
